import { Controller } from "stimulus";
import { GeckoPrimerInputError } from '../events'

export default class extends Controller {
  static targets = ["text", "password"];

  showErrorTextInput() {
    console.log(this.textTarget.value)
    this.textTarget.dispatchEvent(GeckoPrimerInputError(true, "Error !!!"));
  }

  hideErrorTextInput() {
    console.log(this.textTarget.value)
    this.textTarget.dispatchEvent(GeckoPrimerInputError(false));
  }

  showErrorPasswordInput() {
    this.passwordTarget.dispatchEvent(GeckoPrimerInputError(true, "Password Error Message"));
  }

  hideErrorPasswordInput() {
    this.passwordTarget.dispatchEvent(GeckoPrimerInputError(false));
  }
}
